import SiteFooter from "../SiteFooter";
import css from "./DiscordPageStyles";
import { DiscordIcon } from "../../utils/Icons";
import DiscordPageHeroSection from "./DiscordPageHeroSection";
import DiscordAboutCommunity from "./DiscordAboutCommunity";
import DiscordServerStructure from "./DiscordServerStructure";
import DiscordCommander from "./DiscordCommander";
import DiscordWeeklyFlow from "./DiscordWeeklyFlow";
import DiscordScoring from "./DiscordScoring";
import DiscordRanks from "./DiscordRanks";
import DiscordMedals from "./DiscordMedals";
import DiscordServerBots from "./DiscordServerBots";
import {
  AV_COLORS,
  AV_EMOJIS,
  COMMUNITY_REGISTER_LINK,
  DISCORD_LINK as INVITE,
} from "./data/DiscordPageData";

const Divider = () => (
  <div className="dsc-hr">
    <div className="dsc-hr-line" />
  </div>
);

/* ══════════════════════════════════════════════════════════════════════════════
   PAGE
══════════════════════════════════════════════════════════════════════════════ */
export default function DiscordPage() {
  return (
    <>
      <div className="dsc">
        <style>{css}</style>
        <div className="dsc-grain" aria-hidden />

        <DiscordPageHeroSection />
        <DiscordAboutCommunity />

        <Divider />
        <DiscordServerStructure />

        <Divider />
        <DiscordCommander />

        <Divider />
        <DiscordWeeklyFlow />

        <Divider />
        <DiscordScoring />

        <Divider />
        <DiscordRanks />

        <Divider />
        <DiscordMedals />

        <Divider />
        <DiscordServerBots />

        {/* ── BOTTOM CTA ───────────────────────────────────────────── */}
        <div className="dsc-bottom">
          <div className="dsc-bottom-orb" aria-hidden />
          <div className="dsc-bottom-inner">
            <div className="dsc-avatars">
              {AV_EMOJIS.map((em, i) => (
                <div
                  key={i}
                  className="dsc-av"
                  style={{ background: AV_COLORS[i] }}
                >
                  {em}
                </div>
              ))}
              <div className="dsc-av dsc-av-k">+9K</div>
              <span className="dsc-av-label">
                <strong>10,000+</strong> already inside
              </span>
            </div>

            <h2 className="dsc-bottom-h2">
              YOUR TEAM
              <br />
              <span className="shimmer">IS WAITING.</span>
            </h2>
            <p className="dsc-bottom-sub">
              Find your squad, pick up a project, earn your rank, and one day
              command your own company. The invite is free — the opportunity is
              real.
            </p>

            <div className="dsc-cta-row">
              <a
                href={INVITE}
                target="_blank"
                rel="noopener noreferrer"
                className="dsc-btn-join"
              >
                <DiscordIcon size={20} />
                Join Discord — It's Free
              </a>
              <a
                href={COMMUNITY_REGISTER_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="dsc-btn-ghost"
              >
                Create portal account ↗
              </a>
            </div>
          </div>
        </div>
      </div>
      <SiteFooter />
    </>
  );
}
